module.exports = __webpack_public_path__ + "img/sugar_hanger_2.0e0cb0a0.jpg";